module.exports = __webpack_public_path__ + "img/exhibition.ec724805.png";